<!-- Navbar -->
<app-navbar></app-navbar>

<!-- Main Content -->
<router-outlet></router-outlet>
